import { Button, Card, Empty, Space, Spin, Table, Typography, message } from 'antd'

import { ProTable } from '@ant-design/pro-components'
import React from 'react'
import { api } from '../../services/api'
import { useQuery } from '@tanstack/react-query'

const { Title } = Typography
export const Contracts = () => {

    const [loading, setLoading] = React.useState(false)

    const { data, refetch } = useQuery({
        queryKey: ['studentData'],
        queryFn: () =>
            api.get('/panel/student-dashboard').then((response) => {
                return response.data.data
            }).catch((error) => {
                message.error('Erro ao carregar dados do estudante');
            })
    },)
    const actionRef = React.useRef(null)

    const courses = data?.courses_info;
    const columns = [
        {
            title: 'Curso',
            dataIndex: 'course_name',
            key: 'course_name',
        },

        {
            title: 'Ações',
            dataIndex: 'actions',
            key: 'actions',
            width: 200,
            render: (text, record) => {
                    return <Button
                        type="primary"
                        onClick={() => getContract(record)}
                        loading={loading}
                    >
                        Ver Contrato
                    </Button>
            }
        }
    ]

    const getSignature = async (course) => {
        try {
            setLoading(true);
            await api.post('/panel/create-envelope', {
                enrollment_id: course?.enrollment_id,
            });

            message.success('Contrato enviado com sucesso');

            refetch();

        } catch (error) {
            console.log(error);
            message.error('Erro ao reenviar contrato');
        } finally {
            setLoading(false);
        }
    }

    const getContract = async (course) => {
        try {
            setLoading(true);
            const { data } = await api.get(`/panel/signed-document/${course.enrollment_id}`,);

            if (data?.contract) {
                window.open(data?.contract, '_blank');
            } else {
                message.warning('Contrato não encontrado');
            }

        } catch (error) {
            const { message: errorMessage } = error.response.data
            errorMessage ? message.error(errorMessage) : message.error('Erro ao carregar contrato');
        } finally {
            setLoading(false);
        }
    }


    return (
        <Spin
            spinning={loading}
            tip="Carregando..."
        >

            <div
                style={{
                    padding: '0px 24px',
                }}
            >



                <ProTable
                    style={{
                        marginBottom: "16px",
                    }}
                    tableStyle={{
                        overflow: "auto",
                        //height pegar do tamanho da tela
                        minHeight: "calc(100vh - 200px)",
                    }}
                    columns={columns}
                    dataSource={courses}
                    rowKey="hash"
                    dateFormatter="string"
                    headerTitle={
                        <Title
                            level={5}
                            style={{
                                fontWeight: "bold",
                                margin: 0,
                                textTransform: "uppercase",
                            }}
                        >
                            Contratos
                        </Title>
                    }



                    search={false}
                    pagination={{
                        pageSize: 25,
                        showSizeChanger: false,
                        showQuickJumper: false,
                        showTotal: (total, range) =>
                            `${range[0]}-${range[1]} de ${total} itens`,
                    }}
                    options={{
                        setting: false,
                        search: false,
                        reload: false,
                        fullScreen: false,
                        density: false,
                    }}
                    cardBordered
                    columnEmptyText=""
                    actionRef={actionRef}
                    onDataSourceChange={(data) => {
                        message.success(
                            `Total de ${data.length} itens encontrados`
                        );
                    }}
                    defaultData={[]}
                    locale={{
                        emptyText: (
                            <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={<span>Nenhum pagamento encontrado</span>}
                            />
                        ),
                    }}
                    bordered
                />


            </div>
        </Spin>
    )
}
